import { createFileRoute } from '@tanstack/react-router';
import { OrderList } from '@/components/sales/order-list';

export const Route = createFileRoute('/sales/sales-orders/')({ component: SalesOrders });

function SalesOrders() {
  return <OrderList kind="sales_order" />;
}
